import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Select } from 'shared/components/Form';
import styles from './JobSort.module.scss';


const JobSort = ({ loggedIn, fullWidth, withRelevancyOptions, value, onChange, className }) => {
  const { t } = useTranslation('common');

  const onSortChange = ({ target: { value: v } }) => onChange(v);

  const sortOptions = loggedIn ? [
    { value: '', label: t('jobs.sortByScoreDesc') },
    { value: 'score:asc', label: t('jobs.sortByScoreAsc') },
    withRelevancyOptions ? { value: 'relevancy:desc', label: t('jobs.sortByRelevancyDesc') } : null,
    withRelevancyOptions ? { value: 'relevancy:asc', label: t('jobs.sortByRelevancyAsc') } : null,
    { value: 'salary:desc', label: t('jobs.sortBySalaryDesc') },
    { value: 'salary:asc', label: t('jobs.sortBySalaryAsc') },
    { value: 'date:desc', label: t('jobs.sortByCreationDesc') },
    { value: 'date:asc', label: t('jobs.sortByCreationAsc') }
  ] : [
    withRelevancyOptions ? { value: '', label: t('jobs.sortByRelevancyDesc') } : null,
    withRelevancyOptions ? { value: 'relevancy:asc', label: t('jobs.sortByRelevancyAsc') } : null,
    { value: withRelevancyOptions ? 'date:desc' : '', label: t('jobs.sortByCreationDesc') },
    { value: 'date:asc', label: t('jobs.sortByCreationAsc') },
    { value: 'salary:desc', label: t('jobs.sortBySalaryDesc') },
    { value: 'salary:asc', label: t('jobs.sortBySalaryAsc') }
  ];

  return (
    <div className={cn(styles.sortby, { [styles.fullWidth]: fullWidth }, className)}>
      <label htmlFor="jobs-sort">{t('jobs.sortByLabel')}</label>
      <Select
        id="jobs-sort"
        name="sort"
        value={value}
        onChange={onSortChange}
        options={sortOptions.filter(Boolean)}
        size="small"
      />
    </div>
  );
};

JobSort.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  loggedIn: PropTypes.bool,
  fullWidth: PropTypes.bool,
  withRelevancyOptions: PropTypes.bool,
  className: PropTypes.string,
};

JobSort.defaultProps = {
  value: '',
  onChange() {},
  loggedIn: false,
  fullWidth: false,
  withRelevancyOptions: false,
  className: null,
};

export default JobSort;
